// bootstrap to load asynchronously for module federation
import('./bootstrap');
